import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/publicClassify',
  component: Layout,
  redirect: '/publicClassify/index',
  name: 'PublicClassify',
  meta: {
    title: '公共分类管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'PublicClassifyIndex',
      component: () => import('@/views/publicClassify/index.vue'),
      meta: {
        title: '公共分类管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/publicClassify"
      },
    }
  ],
}

export default routes
